const digest = 'a6f9627bac17e4a73fd643dafbadea3a8d182c2f73b5a8a8034d5e5d14d1b3e9';
const css = `aside._offlineWarning_qlsh0_1{position:fixed;width:100%;z-index:1002}._offlineFontFetcher_qlsh0_7{position:absolute}._offlineFontFetcher_qlsh0_7:before{content:" "}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'offlineWarning': '_offlineWarning_qlsh0_1', 'offlineFontFetcher': '_offlineFontFetcher_qlsh0_7' };
export const offlineWarning = '_offlineWarning_qlsh0_1';
export const offlineFontFetcher = '_offlineFontFetcher_qlsh0_7';
export { css, digest };